import VueI18n from 'vue-i18n';
import Vue from 'vue';
// @ts-ignore
import en from '../en.json';

Vue.use(VueI18n);

const languages = {
  en: en
}

const message = Object.assign(languages);

export const i18n = new VueI18n({
  locale: 'de', // set locale
  fallbackLocale: 'de',
  silentFallbackWarn: true,
  silentTranslationWarn: true,
  messages: message,
});
